/**
 * The app's canonical public origin.
 *
 * Native builds run from https://localhost inside the Capacitor WebView, so
 * window.location.origin is useless for anything a user might see or follow —
 * share links, deep links, checkout redirects. This is the origin that means
 * "Rave Cave" to the outside world, on every platform.
 */
export const WEB_ORIGIN = 'https://ravecave.app';
